import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/mv-img-2.png'
import _imports_1 from '@/assets/images/mv-img-3.png'
import _imports_2 from '@/assets/images/mv-img-1.png'
import _imports_3 from '@/assets/images/teigaku.png'
import _imports_4 from '@/assets/images/text_pc.png'
import _imports_5 from '@/assets/images/point-title-img.png'
import _imports_6 from '@/assets/images-sp/point-title-img.png'
import _imports_7 from '@/assets/images/point-img-1.png'
import _imports_8 from '@/assets/images-sp/point-img-1.png'
import _imports_9 from '@/assets/images/point-img-4.png'
import _imports_10 from '@/assets/images-sp/point-img-4.png'
import _imports_11 from '@/assets/images/point-img-2.png'
import _imports_12 from '@/assets/images-sp/point-img-2.png'
import _imports_13 from '@/assets/images/point-img-3.png'
import _imports_14 from '@/assets/images-sp/point-img-3.png'
import _imports_15 from '@/assets/images/lineup-title-img.png'
import _imports_16 from '@/assets/images/main-banner-iphone-img.png'
import _imports_17 from '@/assets/images-sp/main-banner-iphone-img.png'
import _imports_18 from '@/assets/images/logo-new.png'
import _imports_19 from '@/assets/images/flow-img-1.jpg'
import _imports_20 from '@/assets/images/flow-img-2.jpg'
import _imports_21 from '@/assets/images/flow-img-3.jpg'
import _imports_22 from '@/assets/images/flow-img-4.jpg'
import _imports_23 from '@/assets/images/flow-img-5.jpg'
import _imports_24 from '@/assets/images/slider-img-1.jpg'
import _imports_25 from '@/assets/images/slider-img-2.jpg'
import _imports_26 from '@/assets/images/slider-img-3.jpg'
import _imports_27 from '@/assets/images/aisatsu-main-img.png'
import _imports_28 from '@/assets/images-sp/aisatsu-main-img.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-f7a57b6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mv-area-first" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-view-slick__container" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "main-view-slick of" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "slick-slide",
        src: _imports_0,
        width: "930",
        height: "400"
      })
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "slick-slide",
        src: _imports_1,
        width: "930",
        height: "400"
      })
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "slick-slide",
        src: _imports_2,
        width: "930",
        height: "400"
      })
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "slick-slide",
        src: _imports_0,
        width: "930",
        height: "400"
      })
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "slick-slide",
        src: _imports_1,
        width: "930",
        height: "400"
      })
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "slick-slide",
        src: _imports_2,
        width: "930",
        height: "400"
      })
    ])
  ])
], -1))
const _hoisted_3 = { class: "mv-area-second" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mv-area-second__container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mv-area-second__paymentBox" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "mv-area-second__paymentBox__inner" }, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "teigaku",
        src: _imports_3,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "price",
        src: _imports_4,
        alt: ""
      })
    ])
  ])
], -1))
const _hoisted_5 = { class: "find-area__inner" }
const _hoisted_6 = { class: "find-area__container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "find-area-title" }, " 利用可能なクルマを探す ", -1))
const _hoisted_8 = { class: "find-area__buttonBox" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "find-area-button__large" }, "埼玉", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "find-area-button__large" }, "大阪", -1))
const _hoisted_11 = { class: "find-area__buttonBox" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "find-area-button__large" }, "宮城", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "find-area-button__large" }, "福岡", -1))
const _hoisted_14 = { class: "top-point-content" }
const _hoisted_15 = { class: "wrapper" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "top-sec-point",
  class: "top-point-content-title"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-title-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      width: "664",
      height: "61",
      class: "pc tab"
    }),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_6,
      width: "664",
      height: "61",
      class: "mobi"
    })
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-main-text" }, [
  /*#__PURE__*/_createTextVNode(" 『スズキ定額マイカー』は6ケ月間定額で、"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("スズキ車のオーナーになれる"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("サブスクリプションサービスです。 ")
], -1))
const _hoisted_18 = { class: "top-point-content-in" }
const _hoisted_19 = { class: "sec-1" }
const _hoisted_20 = { class: "top-point-content-in-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "big red" }, "6ケ月契約"),
  /*#__PURE__*/_createTextVNode("だから"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createElementVNode("span", { class: "big blue" }, "気軽"),
  /*#__PURE__*/_createTextVNode("に利用できる。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "big blue" }, "車との新しい付き合い方"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("のご提案。 ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-img-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    width: "743",
    height: "358",
    class: "pc tab"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    width: "587",
    height: "353",
    class: "mobi"
  })
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-img-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    width: "1368",
    height: "754",
    class: "pc tab"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    width: "1120",
    height: "774",
    class: "mobi"
  })
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-text" }, [
  /*#__PURE__*/_createTextVNode(" 「クルマが必要なのは短期間だけ」"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("「クルマがある生活を試してみたい」"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("「新車の購入を考えているけど、"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("実際に試してみたい」"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("そんな、"),
  /*#__PURE__*/_createElementVNode("span", { class: "line" }, "お客様のさまざまなニーズ"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("にお応えします。 ")
], -1))
const _hoisted_25 = { class: "sec-2" }
const _hoisted_26 = { class: "top-point-content-in-box" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-title" }, [
  /*#__PURE__*/_createTextVNode(" 申し込みは"),
  /*#__PURE__*/_createElementVNode("span", { class: "big red" }, "スマホで簡単。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("納車まで来店不要だから"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createElementVNode("span", { class: "big blue" }, "手続きラクラク。")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-img-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    width: "888",
    height: "235",
    class: "pc tab"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_12,
    width: "557",
    height: "500",
    class: "mobi"
  })
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-text" }, [
  /*#__PURE__*/_createTextVNode(" 申し込み・審査はWEBで対応。"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("契約手続きも"),
  /*#__PURE__*/_createElementVNode("br", { class: "pc tab" }),
  /*#__PURE__*/_createTextVNode("自宅でできるので、"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("納車まで来店不要。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "line" }, "自分の時間に合わせて"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("手続きを進めることができます。 ")
], -1))
const _hoisted_30 = { class: "sec-3" }
const _hoisted_31 = { class: "top-point-content-in-box" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "big red" }, "先進安全技術"),
  /*#__PURE__*/_createTextVNode("を搭載した"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("スズキ車をラインアップ ")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-img-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_13,
    width: "858",
    height: "260",
    class: "pc tab"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_14,
    width: "538",
    height: "453",
    class: "mobi"
  })
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-in-box-text" }, [
  /*#__PURE__*/_createTextVNode(" 対象車種は、"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("「スズキセーフティサポート」"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("を搭載したスズキ認定中古車。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 初めて車を運転される方から、"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("子育て世代、運転に不安を感じはじめた"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("シニア世代の方まで、"),
  /*#__PURE__*/_createElementVNode("span", { class: "line" }, [
    /*#__PURE__*/_createTextVNode("安心・安全な"),
    /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
    /*#__PURE__*/_createTextVNode("マイカーライフ")
  ]),
  /*#__PURE__*/_createElementVNode("br", { class: "pc tab" }),
  /*#__PURE__*/_createTextVNode("を送れます。 ")
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-big-text" }, [
  /*#__PURE__*/_createTextVNode(" 手軽な乗り方で"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("身軽なくらしが"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("走り出す。 ")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-point-content-text" }, [
  /*#__PURE__*/_createTextVNode(" あなたの生活に"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("フィットしたカーライフを、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("はじめてみませんか。 ")
], -1))
const _hoisted_37 = { class: "top-lineup-content" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-lineup-content-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "top-lineup-content-title-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_15,
      width: "804",
      height: "128"
    })
  ])
], -1))
const _hoisted_39 = { class: "top-lineup-content-in" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-lineup-content-in-title" }, " 軽乗用車 ", -1))
const _hoisted_41 = {
  key: 0,
  class: "top-lineup-content-in-list"
}
const _hoisted_42 = { class: "top-lineup-content-in-list-in" }
const _hoisted_43 = { class: "top-lineup-content-in-list-in-img" }
const _hoisted_44 = ["src"]
const _hoisted_45 = { class: "top-lineup-content-in-list-in-logo-img" }
const _hoisted_46 = { class: "top-lineup-content-in-list-in-price sans" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tax" }, "（税込）", -1))
const _hoisted_48 = { class: "top-lineup-content-in-list-in-btn-list" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sans" }, "エリアで探す", -1))
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sans" }, "エリアで探す", -1))
const _hoisted_53 = { key: 2 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sans" }, "エリアで探す", -1))
const _hoisted_55 = { key: 3 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sans" }, "エリアで探す", -1))
const _hoisted_57 = {
  key: 1,
  class: "top-lineup-content-in-list-in-logo-img"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-lineup-content-in-title" }, " 乗用車 ", -1))
const _hoisted_59 = {
  key: 0,
  class: "top-lineup-content-in-list"
}
const _hoisted_60 = { class: "top-lineup-content-in-list-in" }
const _hoisted_61 = { class: "top-lineup-content-in-list-in-img" }
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "top-lineup-content-in-list-in-logo-img" }
const _hoisted_64 = { class: "top-lineup-content-in-list-in-price sans" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tax" }, "（税込）", -1))
const _hoisted_66 = { class: "top-lineup-content-in-list-in-btn-list" }
const _hoisted_67 = { key: 0 }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sans" }, "エリアで探す", -1))
const _hoisted_69 = { key: 1 }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sans" }, "エリアで探す", -1))
const _hoisted_71 = { key: 2 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sans" }, "エリアで探す", -1))
const _hoisted_73 = { key: 3 }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sans" }, "エリアで探す", -1))
const _hoisted_75 = {
  key: 1,
  class: "top-lineup-content-in-list-in-logo-img"
}
const _hoisted_76 = { class: "lineup-main-banner" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "big pink" }, "スズキ定額マイカー"),
  /*#__PURE__*/_createTextVNode("で"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createElementVNode("span", { class: "big blue" }, "新しいカーライフ"),
  /*#__PURE__*/_createTextVNode("を"),
  /*#__PURE__*/_createElementVNode("span", { class: "big italic" }, "！")
], -1))
const _hoisted_78 = { class: "lineup-main-banner-box of" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-box-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_16,
    width: "261",
    height: "486",
    class: "pc tab"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_17,
    width: "500",
    height: "400",
    class: "mobi"
  })
], -1))
const _hoisted_80 = { class: "lineup-main-banner-box-info" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-box-info-logo-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_18,
    width: "649",
    height: "90"
  })
], -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-box-info-main" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-box-info-main-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "big" }, "自動車保険、諸費用"),
    /*#__PURE__*/_createElementVNode("span", { class: "big red" }, [
      /*#__PURE__*/_createTextVNode("コミコミ"),
      /*#__PURE__*/_createElementVNode("span", { class: "italic" }, "！")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-box-info-main-price of" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-box-info-main-price-text" }, " 月額 "),
    /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-box-info-main-price-in" }, " 32,000 "),
    /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-box-info-main-price-text-2" }, [
      /*#__PURE__*/_createTextVNode(" 円"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("(税込)～ ")
    ])
  ])
], -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lineup-main-banner-box-info-text sans" }, [
  /*#__PURE__*/_createTextVNode(" 『スズキ定額マイカー』は6ケ月間定額で、"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi tab" }),
  /*#__PURE__*/_createTextVNode("スズキ車のオーナーになれる"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("サブスクリプションサービスです。 ")
], -1))
const _hoisted_84 = {
  id: "top-sec-flow",
  class: "top-flow-content"
}
const _hoisted_85 = { class: "wrapper" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-title" }, " ご利用までの流れ ", -1))
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "top-flow-content-list" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-img" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_19,
        width: "220",
        height: "190"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-title" }, "STEP 01"),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-text" }, " クルマを選ぶ ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-img" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_20,
        width: "220",
        height: "190"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-title" }, "STEP 02"),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-text" }, " 審査を申し込む ")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-img" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_21,
        width: "220",
        height: "190"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-title" }, "STEP 03"),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-text" }, [
      /*#__PURE__*/_createTextVNode(" 成約メールを"),
      /*#__PURE__*/_createElementVNode("br", { class: "pc tab" }),
      /*#__PURE__*/_createTextVNode("送信する ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-img" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_22,
        width: "220",
        height: "190"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-title" }, "STEP 04"),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-text" }, [
      /*#__PURE__*/_createTextVNode(" お手元に届いた書類に必要事項を記入、"),
      /*#__PURE__*/_createElementVNode("br", { class: "pc tab" }),
      /*#__PURE__*/_createTextVNode("郵送する ")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-img" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_23,
        width: "220",
        height: "190"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-title" }, "STEP 05"),
    /*#__PURE__*/_createElementVNode("div", { class: "top-flow-content-list-text" }, " お店でクルマを受取る ")
  ])
], -1))
const _hoisted_88 = {
  id: "top-sec-shop",
  class: "top-area-content"
}
const _hoisted_89 = { class: "wrapper" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-area-content-title" }, " 対応エリア・店舗 ", -1))
const _hoisted_91 = { class: "find-area__buttonBox" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "find-area-button__large" }, "埼玉", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "find-area-button__large" }, "大阪", -1))
const _hoisted_94 = { class: "find-area__buttonBox" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "find-area-button__large" }, "宮城", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "find-area-button__large" }, "福岡", -1))
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "top-slider-list of" }, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_24,
      width: "562",
      height: "400"
    })
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_25,
      width: "592",
      height: "400"
    })
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_26,
      width: "592",
      height: "400"
    })
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_24,
      width: "562",
      height: "400"
    })
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_25,
      width: "592",
      height: "400"
    })
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_26,
      width: "592",
      height: "400"
    })
  ])
], -1))
const _hoisted_98 = { class: "top-news-content" }
const _hoisted_99 = { class: "wrapper" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-news-content-title" }, "新着情報", -1))
const _hoisted_101 = {
  key: 0,
  class: "top-news-content-list sans"
}
const _hoisted_102 = { class: "top-news-content-list-date" }
const _hoisted_103 = { class: "top-news-content-list-title" }
const _hoisted_104 = {
  key: 1,
  class: "top-news-content-list sans"
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "top-news-content-list-title" }, " 新着情報はありません。 ")
], -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = { class: "top-main-content" }
const _hoisted_108 = {
  id: "top-sec-faq",
  class: "top-qa-content"
}
const _hoisted_109 = { class: "wrapper" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-qa-content-title" }, " よくあるご質問・ご相談 ", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "top-qa-content-list of sans" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "li-1 now" }, "サービス内容"),
  /*#__PURE__*/_createElementVNode("li", { class: "li-2" }, "ご利用条件"),
  /*#__PURE__*/_createElementVNode("li", { class: "li-3" }, "料金・お支払い"),
  /*#__PURE__*/_createElementVNode("li", { class: "li-4" }, "申し込み手続き"),
  /*#__PURE__*/_createElementVNode("li", { class: "li-5" }, "ご利用中"),
  /*#__PURE__*/_createElementVNode("li", { class: "li-6" }, "その他")
], -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-qa-content-in sans con-1 now" }, [
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "スズキ定額マイカーの特長はなんですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("頭金なしの6か月間定額で、スズキ車のオーナーになれるサブスクリプションサービスです。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 月額料金に自動車保険が含まれており、ＥＴＣやドライブレコーダーも標準装備しています。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "利用期間は自由に選べるのでしょうか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "利用期間は6ケ月のみとなります。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "月額費用には何が含まれますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("⾞両利⽤料に加え、ご契約期間中に発生する各種税金、登録（届出）手数料、保険料（自賠責保険・自動車保険）が含まれます。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" ガソリン代、駐車場代などはお客様のご負担となります。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "標準装備を教えてください。"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "ドライブレコーダー、カーナビ、ETC、フロアマット、ドアバイザ－はすべてのクルマに標準搭載装備として設置されています。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "自動車ローンプランや残価設定型プランとの違いはなんですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("自動車ローンや残価設定型プランの場合、自動車税や自動車保険のお手続きはお客様で行っていただきます。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" スズキ定額マイカーでは税金や自動車保険はすでに月額料金に含まれているので、ご自身でする手間がかかりません。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "ホームページ上に掲載されているクルマ以外でも申し込めますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "本サービスの対象となっているクルマはホームページ上に掲載されているクルマのみとなっております。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "申し込み前にクルマを確認することはできますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "実車確認はできません。サイト上の車両状態証明書で車両状態を確認することができます。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "「わ」ナンバーになりますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "レンタカーではないので「わ」や「れ」ナンバーにはなりません。")
    ])
  ])
], -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-qa-content-in sans con-2" }, [
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "車内は喫煙可能ですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "全車禁煙車となっております（電子タバコを含む）。喫煙された場合、返却時にルームクリーニング費用の清算が必要です。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, " ペットを乗せて使うことはできますか？ "),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "ペットを乗せてご利用される場合は、必ずケージをご使用いただくようお願いいたします。返却時に、ペットによる汚れ（毛）・臭いの除去等が必要な場合は、原状回復に必要な費用をお支払いいただく場合もございます。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "走行距離の制限はありますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "6ケ月で6,000km以内の走行距離制限がございます。制限を超過された場合は、超過1kmにつき10円（税込）が別途発生いたします。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "法人の申し込みはできますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "できません。個人のご利用のみとなります。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "未成年でも申し込みできますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "未成年の方はお申し込みできません")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "取り扱い店舗以外の都道府県に在住ですが、利用可能でしょうか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "取り扱い店舗と同一都道府県内に在住の方のみご利用可能です。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "複数台の申し込みはできますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "同時に複数台のお申し込みは出来ません。")
    ])
  ])
], -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-qa-content-in sans con-3" }, [
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "頭金は必要ですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "不要です。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "ボーナス払いは利用できますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "ボーナス払いは利用できません。毎月定額払いとなります。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "支払方法を教えてください"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "クレジットカードでのお支払いのみとなります。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "契約者と異なる名義のクレジットカードでも登録が可能ですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "契約者と同じ名義のクレジットカードをご登録ください。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "引き落としはいつからですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("契約開始月の翌月10日にクレジットカード会社へ請求します。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 以降、毎月10日に登録いただいたクレジットカード会社へ請求します。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" ※クレジットカード会社からお客さまへのご請求日はクレジットカード会社により異なります ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "クルマ返却時に追加で費用が発生することはありますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("一般財団法人日本自動車査定協会登録の中古自動車査定士が、返却自動車を減点方式にて査定をさせていただきます。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 査定の結果、引渡時の原状と異なるときは原状回復に要する費用が50点（50,000円）以上の場合、50点を超過した費用をお客様にご負担いただきます。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 6ケ月で6,000km以内の走行距離制限を超過された場合は、超過1kmにつき10円（税込）が別途発生いたします。")
      ])
    ])
  ])
], -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-qa-content-in sans con-4" }, [
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "申し込みから車を受け取る（納車）までの期間はどのくらいですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "お申し込みから納車までに、おおよそ1ヶ月程度お日にちをいただきます。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "住民票住所でなく実際に住んでいる住所で、申し込みできますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "住民票がある住所でのみ、申し込みいただけます。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "審査にかかる時間を教えてください"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "２～３営業日以内に審査結果をご登録いただいたメールアドレスへご連絡いたします。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "申し込み後にキャンセルはできますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("キャンセルは可能です。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" ・申し込みから成約メール送信前まで → キャンセル料なし"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" ・成約メール送信から名義変更前まで → 月額利用料1ヶ月分"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" ・名義変更以降 → 中途解約扱いで、6ヶ月分の月額利用料")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "申し込みをしましたが、メールが届きません"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("迷惑メールなどに振り分けられていないかをご確認ください。また、ドメイン受信設定やメールフィルターで排除されている可能性があります。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" メールを確認できない場合には、スズキ定額マイカーお客様センターへお問い合わせください。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "審査結果の詳細を教えてください"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "詳細はお答えすることはできません。ご容赦ください。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "直接店舗で申し込みたい"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "インターネットでのみ、お申し込みが可能です。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "クルマの受け取りは、取り扱い店舗のみですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "車両のお渡し（納車）は、取り扱い店舗のみとなります。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "自宅までクルマは配送してもらえますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "ご自宅へのお届けは行っておりません。店舗までお越しください。")
    ])
  ])
], -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-qa-content-in sans con-5" }, [
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "契約期間中に県外（府外）に転居した場合はどうなりますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("ご利用中にご契約いただいた県外（府外）へお引越しされる場合、中途解約となります。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 転居が決まり次第、スズキ定額マイカーお客様センターまでご連絡ください。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "他の人も運転できますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "運転者はご契約者様、もしくはご契約者様が許諾した方のみが運転できます。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "車両に異常があった場合はどうしたらいいですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "車両に異常のある場合は、ご利用にならず速やかにスズキ定額マイカーお客様センターへご連絡ください。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "タイヤやワイパーなど、消耗品が破損した場合はどうしたらよいですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "消耗部品はお客様のご負担となります。（パンク等によるタイヤ交換含む）")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "契約内容の変更（住所、クレジットカード情報など）をするにはどうしたらよいですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "スズキ定額マイカーお客様センターへご連絡ください。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "契約期間中に解約したい場合はどうすればよいですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("解約希望の旨をスズキ定額マイカーお客様センターにご連絡ください。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 残契約期間に応じて、中途解約金をお支払いいただき、取り扱い店舗にクルマを返却いただいて解約となります。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 返却時の車両の状態によって、清算金（原状回復費用）が発生する場合があります。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "返却の手続きはどうしたらよいですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("満期の約１カ月前にメールにてご案内いたします。メールが届いてから5日以内に、契約終了し返却するか、再契約するかをご返信ください。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" ご返信がない場合には、返却となりますので、ご了承ください。")
      ])
    ])
  ])
], -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-qa-content-in sans con-6" }, [
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "現在加入している自動車保険を使えますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "使用できません。加入中の保険がある場合は、中断手続きができる場合がありますので、加入中の保険の取扱代理店・引受保険会社にご相談ください。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "事故が起こったときはどうすればいいですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "まずは、速やかに自動車保険会社のコールセンターに連絡してください。併せて、スズキ定額マイカーお客様センターまでご連絡ください。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "車両が盗難にあった場合の対応について"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "スズキ定額マイカーお客様センターまでご連絡ください。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "修理を知り合いの工場に依頼をしてもよいですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "修理は、車両受け渡し店舗にて実施いたしますので、スズキ定額マイカーお客様センターまでご連絡ください。ご連絡いただけない場合は、補償制度が適用できませんのでご注意ください。")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "利用期間後も継続して車を利用したい場合は、どうすればよいですか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("満期の約１カ月前に送信するメールに、再契約の旨をご返信ください。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 併せて新規申し込み時と同様にホームページから申し込み手続き・審査を進めて下さい。審査完了後、取扱店舗と来店希望日を調整のうえご来店いただき、再契約手続き、およびクルマのメンテナンス作業を行います。")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("dl", null, [
    /*#__PURE__*/_createElementVNode("dt", null, "利用しているクルマを購入することはできますか？"),
    /*#__PURE__*/_createElementVNode("dd", null, [
      /*#__PURE__*/_createElementVNode("p", null, "購入することは出来ません")
    ])
  ])
], -1))
const _hoisted_118 = {
  id: "top-sec-contact",
  class: "top-contact-content"
}
const _hoisted_119 = { class: "wrapper" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-contact-content-title" }, [
  /*#__PURE__*/_createTextVNode(" ご不明な点・ご質問など"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("お気軽にお問い合わせください ")
], -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-contact-content-main-text" }, [
  /*#__PURE__*/_createTextVNode(" スズキ定額マイカーお客様センター "),
  /*#__PURE__*/_createElementVNode("div", { class: "top-contact-content-main-text-tel" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "tel-link" }, "0120-3249-66"),
    /*#__PURE__*/_createElementVNode("span", { class: "mini" }, "（通話料無料）")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "top-contact-content-main-text-time" }, [
    /*#__PURE__*/_createTextVNode(" 受付時間：10:00～17:00"),
    /*#__PURE__*/_createElementVNode("span", { class: "mini" }, "（年末年始除く）")
  ])
], -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-contact-content-text sans" }, [
  /*#__PURE__*/_createTextVNode(" お問い合わせの内容によっては、"),
  /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
  /*#__PURE__*/_createTextVNode("回答にお時間を頂戴する場合がございます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 予めご了承くださいますようお願いいたします。 ")
], -1))
const _hoisted_123 = { class: "top-aisatsu-content" }
const _hoisted_124 = { class: "wrapper" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-aisatsu-content-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_27,
    width: "1100",
    height: "550",
    class: "pc tab"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_28,
    width: "650",
    height: "350",
    class: "mobi"
  })
], -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-aisatsu-content-text" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("みんなが乗れるクルマづくりを、"),
    /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
    /*#__PURE__*/_createTextVNode("クルマとの付き合い方まで広げたい。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" そんな想いをカタチにした、"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("暮らしをちょっとよくする"),
    /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
    /*#__PURE__*/_createTextVNode("サブスクリプションサービス。")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("手軽な乗り方で、身軽なくらしが走り出す。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" あなたの生活にフィットしたカーライフを、"),
    /*#__PURE__*/_createElementVNode("br", { class: "mobi" }),
    /*#__PURE__*/_createTextVNode("はじめてみませんか。")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_mail_magazine_form = _resolveComponent("mail-magazine-form")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, { to: "/car?area=埼玉" }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createTextVNode("エリアで探す")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/car?area=大阪" }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createTextVNode("エリアで探す")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_router_link, { to: "/car?area=宮城" }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createTextVNode("エリアで探す")
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/car?area=福岡" }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createTextVNode("エリアで探す")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("section", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }),
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }),
                _hoisted_24,
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/service#link01",
                      class: "top-point-content-in-box-link-btn sans"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 詳しくはこちら ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("section", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                }),
                _hoisted_29,
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/service/#link02",
                      class: "top-point-content-in-box-link-btn sans"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 詳しくはこちら ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("section", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _hoisted_33
                  ]),
                  _: 1
                }),
                _hoisted_34,
                _createVNode(_component_center, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, {
                      to: "/service#link03",
                      class: "top-point-content-in-box-link-btn sans"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 詳しくはこちら ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _hoisted_35,
          _hoisted_36
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_center, null, {
          default: _withCtx(() => [
            _hoisted_38
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("section", null, [
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _hoisted_40
              ]),
              _: 1
            }),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_41, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineupLight, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.item_id,
                      class: _normalizeClass({ osusume: item.recommendFlag })
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("img", {
                            src: item.imagePaths[0],
                            width: "600",
                            height: "300"
                          }, null, 8, _hoisted_44)
                        ]),
                        _createVNode(_component_center, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_45, _toDisplayString(item.carName), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_46, [
                          _createTextVNode(" 月額" + _toDisplayString(item.carName == 'アルト' ? Number(32000).toLocaleString() : Number(item.price).toLocaleString()) + "円", 1),
                          _hoisted_47,
                          _createTextVNode("〜 ")
                        ]),
                        _createElementVNode("ul", _hoisted_48, [
                          (item.saitamaHasStocks)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                                _createVNode(_component_router_link, {
                                  to: `/car?area=埼玉&carName=${item.carName}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("埼玉"),
                                    _hoisted_50
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (item.osakaHasStocks)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_51, [
                                _createVNode(_component_router_link, {
                                  to: `/car?area=大阪&carName=${item.carName}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("大阪"),
                                    _hoisted_52
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (item.miyagiHasStocks)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                                _createVNode(_component_router_link, {
                                  to: `/car?area=宮城&carName=${item.carName}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("宮城"),
                                    _hoisted_54
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (item.fukuokaHasStocks)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_55, [
                                _createVNode(_component_router_link, {
                                  to: `/car?area=福岡&carName=${item.carName}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("福岡"),
                                    _hoisted_56
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" 読込中... ")
                    ]),
                    _: 1
                  })
                ]))
          ]),
          _createElementVNode("section", null, [
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _hoisted_58
              ]),
              _: 1
            }),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_59, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineupNormal, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item.item_id,
                      class: _normalizeClass({ osusume: item.recommendFlag })
                    }, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("img", {
                            src: item.imagePaths[0],
                            width: "601",
                            height: "301"
                          }, null, 8, _hoisted_62)
                        ]),
                        _createVNode(_component_center, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_63, _toDisplayString(item.carName), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_64, [
                          _createTextVNode(" 月額" + _toDisplayString(Number(item.price).toLocaleString()) + "円", 1),
                          _hoisted_65,
                          _createTextVNode("〜 ")
                        ]),
                        _createElementVNode("ul", _hoisted_66, [
                          (item.saitamaHasStocks)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_67, [
                                _createVNode(_component_router_link, {
                                  to: `/car?area=埼玉&carName=${item.carName}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("埼玉"),
                                    _hoisted_68
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (item.osakaHasStocks)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_69, [
                                _createVNode(_component_router_link, {
                                  to: `/car?area=大阪&carName=${item.carName}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("大阪"),
                                    _hoisted_70
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (item.miyagiHasStocks)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_71, [
                                _createVNode(_component_router_link, {
                                  to: `/car?area=宮城&carName=${item.carName}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("宮城"),
                                    _hoisted_72
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          (item.fukuokaHasStocks)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_73, [
                                _createVNode(_component_router_link, {
                                  to: `/car?area=福岡&carName=${item.carName}`
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("福岡"),
                                    _hoisted_74
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 2))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" 読込中... ")
                    ]),
                    _: 1
                  })
                ]))
          ])
        ]),
        _createElementVNode("div", _hoisted_76, [
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_77
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_78, [
            _hoisted_79,
            _createElementVNode("div", _hoisted_80, [
              _hoisted_81,
              _hoisted_82,
              _hoisted_83,
              _createVNode(_component_router_link, {
                to: "/service",
                class: "lineup-main-banner-box-info-btn sans"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 詳しくはこちら ")
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_86
            ]),
            _: 1
          }),
          _hoisted_87,
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/flow",
                class: "top-flow-content-btn sans"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 詳しくはこちら ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_90
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_91, [
            _createVNode(_component_router_link, { to: "/car?area=埼玉" }, {
              default: _withCtx(() => [
                _hoisted_92,
                _createTextVNode("エリアで探す")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/car?area=大阪" }, {
              default: _withCtx(() => [
                _hoisted_93,
                _createTextVNode("エリアで探す")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createVNode(_component_router_link, { to: "/car?area=宮城" }, {
              default: _withCtx(() => [
                _hoisted_95,
                _createTextVNode("エリアで探す")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, { to: "/car?area=福岡" }, {
              default: _withCtx(() => [
                _hoisted_96,
                _createTextVNode("エリアで探す")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _hoisted_97,
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("div", _hoisted_99, [
          _hoisted_100,
          (!_ctx.loading && _ctx.notices.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_101, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notices, (notice) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: notice.id
                  }, [
                    _createElementVNode("div", _hoisted_102, _toDisplayString(notice.publish_date), 1),
                    _createElementVNode("div", _hoisted_103, _toDisplayString(notice.title ? `${notice.title}　` : '') + _toDisplayString(notice.body), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("ul", _hoisted_104, _hoisted_106))
        ])
      ]),
      _createElementVNode("div", _hoisted_107, [
        _createElementVNode("div", _hoisted_108, [
          _createElementVNode("div", _hoisted_109, [
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _hoisted_110
              ]),
              _: 1
            }),
            _hoisted_111,
            _hoisted_112,
            _hoisted_113,
            _hoisted_114,
            _hoisted_115,
            _hoisted_116,
            _hoisted_117
          ])
        ]),
        _createElementVNode("div", _hoisted_118, [
          _createElementVNode("div", _hoisted_119, [
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _hoisted_120
              ]),
              _: 1
            }),
            _hoisted_121,
            _createVNode(_component_center, null, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, {
                  to: "/inquiry",
                  class: "top-contact-content-btn"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" お問い合わせフォームはこちら ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_122,
            _createVNode(_component_mail_magazine_form)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_123, [
        _createElementVNode("div", _hoisted_124, [
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _hoisted_125
            ]),
            _: 1
          }),
          _hoisted_126
        ])
      ])
    ]),
    _: 1
  }))
}